import { observable } from 'mobx'

class SpeedBallStore {
  @observable
  token: string = ''
  @observable
  client2speedMsg: { time: number; msg: string } | null = null
}

export default new SpeedBallStore()
